import { IBranchSettings } from "../../types/IBranchSettings";
import { defaultOrganisation } from "../../types/IOrganisation";
import { defaultPrinter } from "../../types/IPrinter";
import { defaultStyleSettings } from "../../types/IStyleSettings";
import { IConfiguration } from "./IConfiguration";

let branchSettings: IBranchSettings = {
  organisation: defaultOrganisation,
  printers: [defaultPrinter],
  styleSettings: defaultStyleSettings,
};

export class Configuration implements IConfiguration {
  public setSettings(s: IBranchSettings): void {
    branchSettings = s;
  }
  public getSettings(): IBranchSettings {
    return branchSettings;
  }
}
